module.exports = __webpack_public_path__ + "img/1101.4d2ad502.png";